import { Icon as IconType } from "@/types/icon";
import Icon from "@/components/common/Icon";
import { generateLicenseLink } from "@/utils/links";

interface Props {
  icon: IconType;
  linkTarget: string;
  licenseKey: string;
  locale: string;
  slug: string;
}

export default function LicenseCell({ icon, linkTarget, licenseKey, locale, slug }: Props) {
  const licenseUrl = generateLicenseLink(licenseKey, locale, slug);
  
  return (
    <a
      className="tooltip min-h-[44px] min-w-[44px]"
      href={licenseUrl}
      target={licenseUrl !== '#' ? linkTarget : undefined}
    >
      <Icon
        icon={icon}
        width={110}
        height={60}
        alt="License"
      />
      <span className="tooltiptext">{icon.description?.trim()}</span>
    </a>
  );
}
